import { isEqual } from 'lodash'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import { getPersonListData, _getPDataById } from './../persons/mockData'
import type { TEntityId } from '~/types/models'
import type { IUser } from '~/types/user/models'
import type { IPerson } from '~/types/person/models'

const userListData = undefined as unknown as IUser[]

export const getUserListData = getListDataFunctionFactory<IUser[]>({
  listData: userListData,
  storageKey: 'users',
  getStartingListData: getStartingUserListData,
})

export function _getUDataById(id: TEntityId, list: IUser[]): IUser {
  if (!list) {
    throw new Error(`_getUDataById returned undefined/null`)
  }
  const user = list.find((u: IUser) => u.id === id)
  if (!user) {
    throw new Error(`Can't find user '${id}'`)
  }
  return user
}

export async function getUserDataById(id: string): Promise<IUser> {
  const list: IUser[] = await getUserListData()
  return _getUDataById(id, list)
}

export async function getUserListDataByPersonId(id: string) {
  const listData = await getUserListData()
  return listData.filter((user: IUser) => isEqual(user.person.id, id))
}

export async function getStartingUserListData(): Promise<IUser[]> {
  const pList = await getPersonListData()
  return [
    {
      id: 'XXU0001',
      hrid: 'U0001',
      person: _getPDataById('XXPE0040', pList),
      email: 'jimmy.stewart@privatebank.com',
      primaryGroup: { id: 'XXG0001', label: 'Metropolis Bank' },
      lastLoginDate: '2021-12-01, 9:00 am',
      status: {
        id: 2,
        label: 'Active',
      },
      permissions: {
        dashboards: [
          {
            id: 1,
            label: 'see',
          },
        ],
      },
      settings: {
        routeAfterLogin: 'Companies',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXU0002',
      hrid: 'U0002',
      person: _getPDataById('XXPE0041', pList),
      email: 'rrussell@wxtechnologygroup.com',
      primaryGroup: { id: 'XXG0001', label: 'Metropolis Bank' },
      lastLoginDate: '2021-12-01, 9:30 am',
      status: {
        id: 2,
        label: 'Active',
      },
      permissions: {
        dashboards: [
          {
            id: 1,
            label: 'see',
          },
          {
            id: 2,
            label: 'edit',
          },
        ],
        operations: [
          {
            id: 1,
            label: 'see',
          },
          {
            id: 2,
            label: 'edit',
          },
        ],
      },
      settings: {
        routeAfterLogin: 'Companies',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXU0003',
      hrid: 'U0003',
      person: _getPDataById('XXPE0042', pList),
      email: 'rmitchum@wxtechnologygroup.com',
      primaryGroup: { id: 'XXG0002', label: 'WXTG' },
      lastLoginDate: '2021-12-01, 9:00 am',
      status: {
        id: 2,
        label: 'Active',
      },
      permissions: {
        dashboards: [
          {
            id: 1,
            label: 'see',
          },
          {
            id: 2,
            label: 'edit',
          },
        ],
        operations: [
          {
            id: 1,
            label: 'see',
          },
          {
            id: 2,
            label: 'edit',
          },
        ],
        admin: [
          {
            id: 1,
            label: 'see',
          },
          {
            id: 2,
            label: 'edit',
          },
        ],
      },
      settings: {
        routeAfterLogin: 'Companies',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXU0004',
      hrid: 'U0004',
      person: _getPDataById('XXPE0043', pList),
      email: 'plorre@wxtechnologygroup.com',
      primaryGroup: { id: 'XXG0002', label: 'WXTG' },
      lastLoginDate: '2021-12-01, 1:32 pm',
      status: {
        id: 2,
        label: 'Active',
      },
      permissions: {
        dashboards: [
          {
            id: 1,
            label: 'see',
          },
          {
            id: 2,
            label: 'edit',
          },
        ],
        operations: [
          {
            id: 1,
            label: 'see',
          },
          {
            id: 2,
            label: 'edit',
          },
        ],
        accounting: [
          {
            id: 1,
            label: 'see',
          },
          {
            id: 2,
            label: 'edit',
          },
        ],
        admin: [
          {
            id: 1,
            label: 'see',
          },
          {
            id: 2,
            label: 'edit',
          },
        ],
      },
      settings: {
        routeAfterLogin: 'Companies',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXU0005',
      hrid: 'U0005',
      person: _getPDataById('XXPE0018', pList),
      email: 'merryl@wxtechnologygroup.com',
      primaryGroup: { id: 'XXG0002', label: 'WXTG' },
      lastLoginDate: '2022-12-01, 1:32 pm',
      status: {
        id: 2,
        label: 'Active',
      },
      permissions: {
        dashboards: [
          {
            id: 1,
            label: 'see',
          },
          {
            id: 2,
            label: 'edit',
          },
        ],
        operations: [
          {
            id: 1,
            label: 'see',
          },
          {
            id: 2,
            label: 'edit',
          },
        ],
        accounting: [
          {
            id: 1,
            label: 'see',
          },
          {
            id: 2,
            label: 'edit',
          },
        ],
        admin: [
          {
            id: 1,
            label: 'see',
          },
          {
            id: 2,
            label: 'edit',
          },
        ],
      },
      settings: {
        routeAfterLogin: 'Home',
      },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
